module.exports = __webpack_public_path__ + "img/c_9.63937e48.png";